module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/67b5215a40ed284e31bd327d6303741d.png";